import {insertAt} from '../../../common/helpers';
import {LoggedInEnterprise} from './Types';

const AUTH_LOCAL_STORAGE_KEY = 'enterprise-auth';

const getLocalUser = (): LoggedInEnterprise | null => {
	if (!localStorage) return null;

	const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
	if (!lsValue) return null;

	try {
		const auth: LoggedInEnterprise = JSON.parse(lsValue) as LoggedInEnterprise;
		if (auth) return auth;
	} catch (error) {
		console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
	}

	return null;
};

const setLocalUser = (auth: LoggedInEnterprise) => {
	if (!localStorage) return;

	try {
		const lsValue = JSON.stringify(auth);
		localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
	} catch (error) {
		console.error('AUTH LOCAL STORAGE SAVE ERROR', error);
	}
};

const removeLocalUser = () => {
	if (!localStorage) return;

	try {
		localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
	} catch (error) {
		console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
	}
};

const formatMobile = (user: LoggedInEnterprise) => {
	const phone = user?.enterpriser?.stores?.at(0)?.storePhone;
	if (!phone) return undefined;

	return insertAt(insertAt(phone.replace('+81', '0'), 7, '-'), 3, '-');
};

export {getLocalUser, setLocalUser, removeLocalUser, formatMobile};

export const isMobile = () => {
	return window.matchMedia('(max-width:767px)').matches;
};
